/**
 * @file paddle 客户案例 案例列表 切换开关
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

interface IItemProps {
    value?: string | number;
}

const Item: React.FC<IItemProps> = props => {
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};

export default Item;
